import { HighlightText } from '@/components/ui/table/DataTable/HighlightText'
import type { CellContext } from '@/components/ui/table/types'
import {
  AccountTypeBadge,
  type AccountTypes,
  type Transaction,
} from '@/modules/projects'

export const AccountTypeBadgeCell = (
  cell: CellContext<Transaction, string>,
) => {
  const type = cell.getValue() as AccountTypes
  const searchQuery = cell.table.options.meta?.searchQuery

  if (searchQuery) {
    return (
      <AccountTypeBadge type={type}>
        <HighlightText text={type || ''} query={searchQuery} />
      </AccountTypeBadge>
    )
  }

  return <AccountTypeBadge type={type} />
}
